// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2VpVe","alertIcon":"ConfirmModal_alertIcon__1vmMk"};